import type { SelectionDropdown } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { TABLE_EXPORT_SELECTION_TOP_N_VALUES } from "app/pages/sales-intelligence/constants/options";

import { createExportSelectionDropdown } from "./selectionDropdownFactory";

export const appsExportSelectionDropdown: SelectionDropdown = createExportSelectionDropdown({
    topNValues: TABLE_EXPORT_SELECTION_TOP_N_VALUES,
});
